export default __webpack_public_path__ + "static/media/push29.6f0d58bd.gif";